export default {
  schema: {
    type: "boolean",
  },
  uiSchema: {},
};
